module.exports = __webpack_public_path__ + "static/img/topleft.fee8726.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/topleft.png
// module id = N5hL
// module chunks = 1